'use client';

import React from 'react';

interface ExpandIconProps {
  size?: number;
  color?: string;
}

export const ExpandIcon: React.FC<ExpandIconProps> = ({
  size = 20,
  color = '#202020',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path fill={color} d="m1.667 12.5 8.334-6.25 8.333 6.25-1.48 1.11-6.853-5.141-6.855 5.14z" />
    </svg>
  );
};

export default ExpandIcon;

